import { IGenericInputReturn } from "@/@types/GenericInputProps"
import AppNumericInput from "@/app/components/atomic/Input/AppNumericInput"
import { FilterVariant, IAppliedFilter, INumberFilterConfig } from "@/app/models/auctor"

export default function FilterNumber({
    filterConfig,
    appliedFilter,
    handleChange,
    variant = "default",
}: {
    filterConfig: INumberFilterConfig
    appliedFilter: IAppliedFilter
    handleChange: any
    variant?: FilterVariant
}) {
    const onChange = (inputReturn: IGenericInputReturn) => {
        handleChange(appliedFilter, inputReturn.value)
    }

    return (
        <>
            <AppNumericInput
                onChange={onChange}
                value={appliedFilter.value ?? ""}
                addonContent={filterConfig.addon_content}
                fieldName={filterConfig.variable_name as string}
                min={filterConfig.min_filter_value}
                max={filterConfig.max_filter_value}
                debounce={100}
                borders={variant === "tool" ? "gray" : "neutral"}
                className={variant === "tool" ? "bg-transparent" : undefined}
                addonTheme={variant === "tool" ? "neutral" : undefined}
            />
        </>
    )
}
